import { render, staticRenderFns } from "./WheelSlider.vue?vue&type=template&id=2089f9e4&scoped=true"
import script from "./WheelSlider.vue?vue&type=script&lang=js"
export * from "./WheelSlider.vue?vue&type=script&lang=js"
import style0 from "./WheelSlider.vue?vue&type=style&index=0&id=2089f9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2089f9e4",
  null
  
)

export default component.exports